import React, { useState, Fragment } from 'react';
import { View, Text } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { Button } from 'src/components/Button';
import { Separator } from 'src/components/Separator';
import { Alert, AlertAction } from 'src/components/Alert';

const Example1 = () => {
  const [horizontalActive, toggleHorizontal] = useState(false);
  const [verticalActive, toggleVertical] = useState(false);

  return (
    <Fragment>
      <PanelHeader>📢 Alert</PanelHeader>
      <PlatformPadding vertical horizontal>
        <View>
          <Button before={<Text>↔️</Text>} onPress={() => toggleHorizontal(true)}>
            Show Horizontal
          </Button>
          <Separator />
          <Button before={<Text>↕️</Text>} onPress={() => toggleVertical(true)}>
            Show Vertical
          </Button>
        </View>
      </PlatformPadding>
      <Alert
        visible={horizontalActive}
        type="horizontal"
        title="Confirm action"
        description="Do you really want to perform this destructive and non-recoverable action?"
        onDismiss={() => console.log('alert dismissed')}
        actions={[
          <AlertAction type="cancel" onPress={() => toggleHorizontal(false)} key="cancel">
            Cancel
          </AlertAction>,
          <AlertAction type="destructive" onPress={() => toggleHorizontal(false)} key="remove">
            Remove
          </AlertAction>,
        ]}
      />
      <Alert
        visible={verticalActive}
        type="vertical"
        title="Confirm action"
        description="Do you really want to perform this destructive and non-recoverable action?"
        onDismiss={() => console.log('alert dismissed')}
        actions={[
          <AlertAction type="destructive" onPress={() => toggleVertical(false)} key="remove">
            Remove something
          </AlertAction>,
          <AlertAction onPress={() => toggleVertical(false)} key="default">
            View information
          </AlertAction>,
          <AlertAction type="cancel" onPress={() => toggleVertical(false)} key="cancel">
            Cancel
          </AlertAction>,
        ]}
      />
    </Fragment>
  );
};

storiesOf('Alert', module).add('Default', () => <Example1 />);
